module.exports = __webpack_public_path__ + "ac3727bc600a0cf9601c633982ac525b.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_l_50.mp3
// module id = 460
// module chunks = 0